import { jsx as _jsx } from "react/jsx-runtime";
import { ReportReference } from './report-reference';
import { useSession } from '../../../../infra/session';
import { getUrlPrefixFromView } from '../../../../infra/routing';
var reports = [
    {
        id: 'total-gross-sales',
        title: 'Total Gross Sales',
        description: 'A report of totals for your sales of services, product, and gift cards. Additionally, totals for deposits, payment methods, refunds, discounts, taxes, tips, and fees. Lastly, totals for canceled appointment values, no shows, and unmarked sales.',
        url: '/reports/dashboard/v2',
    },
    {
        id: 'sales-by-service',
        title: 'Sales by Service',
        description: 'A report of totals for your sales of services grouped by service, their payment methods, refunds, discounts, taxes, tips, and fees. Additionally, totals for canceled appointment values, no shows, and unmarked sales.',
        url: '/reports/sales/v2',
    },
    {
        id: 'sales-by-product',
        title: 'Sales by Product',
        description: 'A report of totals for your sales of products grouped by product, their payment methods, refunds, discounts, cost of inventory, and profit. Additionally, totals for taxes and fees.',
        url: '/reports/sales-by-product',
    },
];
export var ReportReferenceContainer = function (_a) {
    var reportId = _a.reportId;
    var report = reports.find(function (reportConfig) { return reportConfig.id === reportId; });
    var session = useSession().data;
    var urlPrefix = getUrlPrefixFromView(session === null || session === void 0 ? void 0 : session.view);
    var reportUrl = "".concat(urlPrefix).concat(report === null || report === void 0 ? void 0 : report.url);
    if (!report) {
        return null;
    }
    return _jsx(ReportReference, { title: report.title, description: report.description, url: reportUrl });
};
